import { render, staticRenderFns } from "./stationCard.vue?vue&type=template&id=30f55029&scoped=true"
import script from "./stationCard.vue?vue&type=script&lang=js"
export * from "./stationCard.vue?vue&type=script&lang=js"
import style0 from "./stationCard.vue?vue&type=style&index=0&id=30f55029&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f55029",
  null
  
)

export default component.exports